import { breakdownChildResponse } from '@functions/amplience-functions';
import getComponents from '@functions/component-functions';
import Breadcrumb from '@repo/ui/src/components/Breadcrumb';

const CategoryBody = ({ body, children, showBreadcrumb, breadcrumb, footer }) => {
  const res = body?.[0]?.schema ? body : breakdownChildResponse(body);
  const footerRes = breakdownChildResponse(footer);

  return (
    <>
      {showBreadcrumb && <Breadcrumb {...breadcrumb} />}
      {res?.map((cmpt) => getComponents(cmpt))}
      {children}
      {footer && footerRes.map((cmpt) => getComponents(cmpt))}
    </>
  );
};

export default CategoryBody;
